import { SSMLTagsColors } from "./colors";

export enum SSMLTag {
  Break = "break",
  Contour = "contour",
  Duration = "duration",
  Emphasis = "emphasis",
  Language = "lang",
  Pitch = "pitch",
  Rate = "rate",
  SayAs = "sayas",
  Voice = "voice",
  Volume = "volume",
  Phoneme = "phoneme",
  Prosody = "prosody",
  Style = "style",
}

export const ssmlTagList: {
  name: string;
  tag: string;
  attribute: string[];
  color: SSMLTagsColors;
}[] = [
  {
    name: "prosody",
    tag: "prosody",
    attribute: ["volume", "rate", "duration", "pitch", "contour"],
    color: SSMLTagsColors.ProsodyTag,
  },
  {
    name: "prosody",
    tag: "rate",
    attribute: ["rate"],
    color: SSMLTagsColors.ProsodyTag,
  },
  {
    name: "prosody",
    tag: "duration",
    attribute: ["duration"],
    color: SSMLTagsColors.ProsodyTag,
  },
  {
    name: "prosody",
    tag: "volume",
    attribute: ["volume"],
    color: SSMLTagsColors.ProsodyTag,
  },
  {
    name: "prosody",
    tag: "pitch",
    attribute: ["pitch"],
    color: SSMLTagsColors.ProsodyTag,
  },
  {
    name: "prosody",
    tag: "contour",
    attribute: ["contour"],
    color: SSMLTagsColors.ProsodyTag,
  },
  {
    name: "lang",
    tag: "lang",
    attribute: ["language", "accent"],
    color: SSMLTagsColors.LanguageTag,
  },
  {
    name: "voice",
    tag: "voice",
    attribute: ["name", "language"],
    color: SSMLTagsColors.VoiceTag,
  },
  {
    name: "style",
    tag: "style",
    attribute: ["name", "intensity"],
    color: SSMLTagsColors.StyleTag,
  },
  {
    name: "break",
    tag: "break",
    attribute: ["time"],
    color: SSMLTagsColors.BreakTag,
  },
  {
    name: "emphasis",
    tag: "emphasis",
    attribute: ["level"],
    color: SSMLTagsColors.EmphasisTag,
  },
  {
    name: "phoneme",
    tag: "phoneme",
    attribute: ["alphabet", "ph"],
    color: SSMLTagsColors.PronunciationTag,
  },
  {
    name: "say-as",
    tag: "sayas",
    attribute: ["interpret-as", "language", "format"],
    color: SSMLTagsColors.SayAsTag,
  },
];

export const underlineStyleTags = [
  SSMLTag.SayAs,
  SSMLTag.Language,
  SSMLTag.Duration,
  SSMLTag.Volume,
  SSMLTag.Rate,
  SSMLTag.Pitch,
  SSMLTag.Contour,
];
